window.YaficoMediaThumbnails = {
  "lighting-01-life-02-v3.webp": {
    "src": "lighting-01-life-02-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-01-life-02-v4.webp": {
    "src": "lighting-01-life-02-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-01-life-03-v3.webp": {
    "src": "lighting-01-life-03-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-01-life-04-v3.webp": {
    "src": "lighting-01-life-04-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-01-life-05-v3.webp": {
    "src": "lighting-01-life-05-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-01-studio-v2.webp": {
    "src": "lighting-01-studio-v2-thumb-320-v1.webp",
    "width": 320,
    "height": 320
  },
  "lighting-02-life-01-v4.webp": {
    "src": "lighting-02-life-01-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-02-life-02-v4.webp": {
    "src": "lighting-02-life-02-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-02-life-03-v3.webp": {
    "src": "lighting-02-life-03-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-02-life-04-v3.webp": {
    "src": "lighting-02-life-04-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-02-life-05-v3.webp": {
    "src": "lighting-02-life-05-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-02-studio-v2.webp": {
    "src": "lighting-02-studio-v2-thumb-320-v1.webp",
    "width": 320,
    "height": 320
  },
  "lighting-03-life-01-v4.webp": {
    "src": "lighting-03-life-01-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-03-life-02-v4.webp": {
    "src": "lighting-03-life-02-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-03-life-03-v3.webp": {
    "src": "lighting-03-life-03-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-03-life-04-v3.webp": {
    "src": "lighting-03-life-04-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-03-life-05-v3.webp": {
    "src": "lighting-03-life-05-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-03-studio-v2.webp": {
    "src": "lighting-03-studio-v2-thumb-320-v1.webp",
    "width": 320,
    "height": 320
  },
  "lighting-04-life-01-v4.webp": {
    "src": "lighting-04-life-01-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-04-life-02-v4.webp": {
    "src": "lighting-04-life-02-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-04-life-03-v3.webp": {
    "src": "lighting-04-life-03-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-04-life-04-v3.webp": {
    "src": "lighting-04-life-04-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-04-life-05-v3.webp": {
    "src": "lighting-04-life-05-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-04-studio-v2.webp": {
    "src": "lighting-04-studio-v2-thumb-320-v1.webp",
    "width": 320,
    "height": 320
  },
  "lighting-05-life-01-v4.webp": {
    "src": "lighting-05-life-01-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-05-life-02-v4.webp": {
    "src": "lighting-05-life-02-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-05-life-03-v3.webp": {
    "src": "lighting-05-life-03-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-05-life-04-v3.webp": {
    "src": "lighting-05-life-04-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-05-life-05-v3.webp": {
    "src": "lighting-05-life-05-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-05-studio-v2.webp": {
    "src": "lighting-05-studio-v2-thumb-320-v1.webp",
    "width": 320,
    "height": 320
  },
  "lighting-06-life-01-v4.webp": {
    "src": "lighting-06-life-01-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-06-life-02-v4.webp": {
    "src": "lighting-06-life-02-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-06-life-03-v3.webp": {
    "src": "lighting-06-life-03-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-06-life-04-v3.webp": {
    "src": "lighting-06-life-04-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-06-life-05-v3.webp": {
    "src": "lighting-06-life-05-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-06-studio-v2.webp": {
    "src": "lighting-06-studio-v2-thumb-320-v1.webp",
    "width": 320,
    "height": 320
  },
  "lighting-07-life-01-v4.webp": {
    "src": "lighting-07-life-01-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-07-life-02-v4.webp": {
    "src": "lighting-07-life-02-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-07-life-03-v3.webp": {
    "src": "lighting-07-life-03-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-07-life-04-v3.webp": {
    "src": "lighting-07-life-04-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-07-life-05-v3.webp": {
    "src": "lighting-07-life-05-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-07-natural-life-01-v1.webp": {
    "src": "lighting-07-natural-life-01-v1-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-07-natural-life-02-v1.webp": {
    "src": "lighting-07-natural-life-02-v1-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-07-natural-life-03-v1.webp": {
    "src": "lighting-07-natural-life-03-v1-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-07-natural-life-04-v1.webp": {
    "src": "lighting-07-natural-life-04-v1-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-07-natural-life-05-v1.webp": {
    "src": "lighting-07-natural-life-05-v1-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-07-natural-studio-lit-v1.webp": {
    "src": "lighting-07-natural-studio-lit-v1-thumb-320-v1.webp",
    "width": 320,
    "height": 320
  },
  "lighting-07-studio-v2.webp": {
    "src": "lighting-07-studio-v2-thumb-320-v1.webp",
    "width": 320,
    "height": 320
  },
  "lighting-08-life-01-v4.webp": {
    "src": "lighting-08-life-01-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-08-life-02-v4.webp": {
    "src": "lighting-08-life-02-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-08-life-03-v3.webp": {
    "src": "lighting-08-life-03-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-08-life-04-v3.webp": {
    "src": "lighting-08-life-04-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-08-life-05-v3.webp": {
    "src": "lighting-08-life-05-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-08-studio-v2.webp": {
    "src": "lighting-08-studio-v2-thumb-320-v1.webp",
    "width": 320,
    "height": 320
  },
  "lighting-09-life-01-v4.webp": {
    "src": "lighting-09-life-01-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-09-life-02-v4.webp": {
    "src": "lighting-09-life-02-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-09-life-03-v3.webp": {
    "src": "lighting-09-life-03-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-09-life-04-v3.webp": {
    "src": "lighting-09-life-04-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-09-life-05-v3.webp": {
    "src": "lighting-09-life-05-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-09-studio-v2.webp": {
    "src": "lighting-09-studio-v2-thumb-320-v1.webp",
    "width": 320,
    "height": 320
  },
  "lighting-10-life-01-v4.webp": {
    "src": "lighting-10-life-01-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-10-life-02-v4.webp": {
    "src": "lighting-10-life-02-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-10-life-03-v3.webp": {
    "src": "lighting-10-life-03-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-10-life-04-v3.webp": {
    "src": "lighting-10-life-04-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-10-life-05-v3.webp": {
    "src": "lighting-10-life-05-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-10-studio-v2.webp": {
    "src": "lighting-10-studio-v2-thumb-320-v1.webp",
    "width": 320,
    "height": 320
  },
  "lighting-11-life-01-v4.webp": {
    "src": "lighting-11-life-01-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-11-life-02-v4.webp": {
    "src": "lighting-11-life-02-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-11-life-03-v3.webp": {
    "src": "lighting-11-life-03-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-11-life-04-v3.webp": {
    "src": "lighting-11-life-04-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-11-life-05-v3.webp": {
    "src": "lighting-11-life-05-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-11-studio-v2.webp": {
    "src": "lighting-11-studio-v2-thumb-320-v1.webp",
    "width": 320,
    "height": 320
  },
  "lighting-12-life-01-v4.webp": {
    "src": "lighting-12-life-01-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-12-life-02-v4.webp": {
    "src": "lighting-12-life-02-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-12-life-03-v3.webp": {
    "src": "lighting-12-life-03-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-12-life-04-v3.webp": {
    "src": "lighting-12-life-04-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-12-life-05-v3.webp": {
    "src": "lighting-12-life-05-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-12-studio-v2.webp": {
    "src": "lighting-12-studio-v2-thumb-320-v1.webp",
    "width": 320,
    "height": 320
  },
  "lighting-13-life-01-v4.webp": {
    "src": "lighting-13-life-01-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-13-life-02-v4.webp": {
    "src": "lighting-13-life-02-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-13-life-03-v3.webp": {
    "src": "lighting-13-life-03-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-13-life-04-v3.webp": {
    "src": "lighting-13-life-04-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-13-life-05-v3.webp": {
    "src": "lighting-13-life-05-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-13-studio-v2.webp": {
    "src": "lighting-13-studio-v2-thumb-320-v1.webp",
    "width": 320,
    "height": 320
  },
  "lighting-14-life-01-v4.webp": {
    "src": "lighting-14-life-01-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-14-life-02-v4.webp": {
    "src": "lighting-14-life-02-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-14-life-03-v3.webp": {
    "src": "lighting-14-life-03-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-14-life-04-v3.webp": {
    "src": "lighting-14-life-04-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-14-life-05-v3.webp": {
    "src": "lighting-14-life-05-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-14-studio-v2.webp": {
    "src": "lighting-14-studio-v2-thumb-320-v1.webp",
    "width": 320,
    "height": 320
  },
  "lighting-15-life-01-v4.webp": {
    "src": "lighting-15-life-01-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-15-life-02-v4.webp": {
    "src": "lighting-15-life-02-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-15-life-03-v3.webp": {
    "src": "lighting-15-life-03-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-15-life-04-v3.webp": {
    "src": "lighting-15-life-04-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-15-life-05-v3.webp": {
    "src": "lighting-15-life-05-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-15-studio-v2.webp": {
    "src": "lighting-15-studio-v2-thumb-320-v1.webp",
    "width": 320,
    "height": 320
  },
  "lighting-16-life-01-v4.webp": {
    "src": "lighting-16-life-01-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-16-life-02-v4.webp": {
    "src": "lighting-16-life-02-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-16-life-03-v3.webp": {
    "src": "lighting-16-life-03-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-16-life-04-v3.webp": {
    "src": "lighting-16-life-04-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-16-life-05-v3.webp": {
    "src": "lighting-16-life-05-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-16-studio-v2.webp": {
    "src": "lighting-16-studio-v2-thumb-320-v1.webp",
    "width": 320,
    "height": 320
  },
  "lighting-17-life-01-v4.webp": {
    "src": "lighting-17-life-01-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-17-life-02-v4.webp": {
    "src": "lighting-17-life-02-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-17-life-03-v3.webp": {
    "src": "lighting-17-life-03-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-17-life-04-v3.webp": {
    "src": "lighting-17-life-04-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-17-life-05-v3.webp": {
    "src": "lighting-17-life-05-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-17-studio-v2.webp": {
    "src": "lighting-17-studio-v2-thumb-320-v1.webp",
    "width": 320,
    "height": 320
  },
  "lighting-18-life-01-v4.webp": {
    "src": "lighting-18-life-01-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-18-life-02-v4.webp": {
    "src": "lighting-18-life-02-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-18-life-03-v3.webp": {
    "src": "lighting-18-life-03-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-18-life-04-v3.webp": {
    "src": "lighting-18-life-04-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-18-life-05-v3.webp": {
    "src": "lighting-18-life-05-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-18-studio-v2.webp": {
    "src": "lighting-18-studio-v2-thumb-320-v1.webp",
    "width": 320,
    "height": 320
  },
  "lighting-19-life-01-v4.webp": {
    "src": "lighting-19-life-01-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-19-life-02-v4.webp": {
    "src": "lighting-19-life-02-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-19-life-03-v3.webp": {
    "src": "lighting-19-life-03-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-19-life-04-v3.webp": {
    "src": "lighting-19-life-04-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-19-life-05-v3.webp": {
    "src": "lighting-19-life-05-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-19-studio-v2.webp": {
    "src": "lighting-19-studio-v2-thumb-320-v1.webp",
    "width": 320,
    "height": 320
  },
  "lighting-20-life-01-v4.webp": {
    "src": "lighting-20-life-01-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-20-life-02-v4.webp": {
    "src": "lighting-20-life-02-v4-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-20-life-03-v3.webp": {
    "src": "lighting-20-life-03-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-20-life-04-v3.webp": {
    "src": "lighting-20-life-04-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-20-life-05-v3.webp": {
    "src": "lighting-20-life-05-v3-thumb-320-v1.webp",
    "width": 320,
    "height": 400
  },
  "lighting-20-studio-v2.webp": {
    "src": "lighting-20-studio-v2-thumb-320-v1.webp",
    "width": 320,
    "height": 320
  }
};
